import { render, staticRenderFns } from "./index.vue?vue&type=template&id=72eaa55f&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72eaa55f')) {
      api.createRecord('72eaa55f', component.options)
    } else {
      api.reload('72eaa55f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=72eaa55f&", function () {
      api.rerender('72eaa55f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/payment-schedule/index.vue"
export default component.exports